import { BACKEND_ROUTES } from "../../../backendRoutes";

export async function saveMissionGeometry({
    patch,
    post,
    missionUuid,
    existingGeometry,
    geometry,
    name,
    type,
    refetchMissionGeometries,
    openSnackbar,
}) {
    if (!missionUuid) return;

    if (existingGeometry) {
        await patch(
            `${BACKEND_ROUTES.MISSION_GEOMETRY}/${existingGeometry.uuid}`,
            {
                body: {
                    name,
                    geometry,
                },
                forwardError: true,
            }
        );
        openSnackbar(`${type} updated successfully`, "success");
    } else {
        await post(
            `${BACKEND_ROUTES.MISSION}/${missionUuid}/mission-geometries`,
            {
                body: {
                    name,
                    type,
                    geometry,
                },
                forwardError: true,
            }
        );
        openSnackbar(`${type} saved successfully`, "success");
    }

    refetchMissionGeometries?.();
}
